@let currentUser = authenticationService.currentUser$ | async;
@let isGuest = currentUser && currentUser.userType === UserType.GUEST;

<div class="menu" [style.width]="currentUser ? '246px': '66px'">
  <ng-container *ngIf="currentUser">
    <div class="menu-item">
      <a class="menu-link" routerLink="/my-invitations/list">
        <lucide-icon [img]="Film"></lucide-icon>
        {{'fspro.front.header.user_feature.label.my_invitations' | translate}}
      </a>
    </div>
    <div class="menu-item" *ngIf="!isGuest">
      <a class="menu-link" routerLink="/my-feed">
        <lucide-icon [img]="Rss"></lucide-icon>
        {{'fspro.front.header.user_feature.label.my_feeds' | translate}}
      </a>
    </div>
    <div class="menu-item" *ngIf="!isGuest">
      <a class="menu-link" routerLink="/my-lists/watched">
        <lucide-icon [img]="ListCheck"></lucide-icon>
        {{'fspro.front.header.user_feature.label.watched' | translate}}
      </a>
    </div>
    <div class="menu-item" *ngIf="!isGuest">
      <a class="menu-link" routerLink="/my-lists/to-watch">
        <lucide-icon [img]="ListRestart"></lucide-icon>
        {{'fspro.front.header.user_feature.label.watch_later' | translate}}
      </a>
    </div>
    <div class="menu-item" *ngIf="!isGuest">
      <a class="menu-link" routerLink="/my-notes/list">
        <lucide-icon [img]="NotebookPen"></lucide-icon>
        {{'fspro.front.header.user_feature.label.my_notes' | translate }}
      </a>
    </div>
    <div class="menu-item" *ngIf="currentUser?.canAccessBookingFeature">
      <a class="menu-link" routerLink="/my-bookings">
        <lucide-icon [img]="CalendarRange"></lucide-icon>
        {{'fspro.front.header.user_feature.label.my_booking' | translate}}
      </a>
    </div>
  </ng-container>
  <div class="menu-item">
    <a class="menu-link" (click)="onOpenContact()">
      <lucide-icon [img]="Mail"></lucide-icon>
      {{'fspro.front.header.user_feature.label.contact' | translate}}
    </a>
  </div>
</div>
